<template>
    <div>
        <el-button type="primary" plain @click="returnPage">返回</el-button>
        <div class="border"></div>
        <el-form label-width="120px" ref="tableData" :model="tableData" label-position="center">
            <el-row :gutter="20">
                <el-col :span="12" :offset="6">
                    <div class="grid-content bg-purple">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="服务分类">
                                    <el-select v-model="tableData.couponType" disabled>
                                        <el-option v-for="item in couponType" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="服务名称">
                                    <el-input v-model="tableData.couponName" readonly></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="售卖价格">
                                    <el-input v-model="tableData.couponPrice" readonly></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="优惠金额">
                                    <el-input v-model="tableData.couponMoney" readonly></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="原价">
                                    <el-input v-model="tableData.serverMoney" readonly></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="有效期">
                                    <el-select v-model="tableData.expirationDate" disabled>
                                        <el-option v-for="item in date" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col>
                                <el-form-item label="已售数量">
                                    <el-input v-model="tableData.sellNumber" readonly></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="用券说明">
                                    <span class="editorContainerInfo ql-editor activesImg" v-html="tableData.couponDescription"></span>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="logo图片">
                                    <img :src="tableData.couponLogoImgUrl" alt="" class="images" />
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="服务图片">
                                    <div v-for="item in tableData.couponServiceImgUrl"  style="display:inline-block;padding-right: 20px;">
                                       <img :src="item" alt="" class="images" />
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col>
                                <el-form-item label="购买须知">
                                    <span class="editorContainerInfo ql-editor activesImg" v-html="tableData.purchaseNote"></span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            url: '',
            id: '',
            tableData: [],
            date: [
                {
                    value: '-1',
                    label: '无期限'
                },
                {
                    value: '3',
                    label: '3天'
                },
                {
                    value: '7',
                    label: '7天'
                },
                {
                    value: '15',
                    label: '15天'
                }
            ],
            couponType: [
                {
                    value: '1',
                    label: '保养券'
                },
                {
                    value: '2',
                    label: '贴膜券'
                },
                {
                    value: '3',
                    label: '改装券'
                },
                {
                    value: '4',
                    label: '商品券'
                },
                {
                    value: '5',
                    label: '洗车券'
                },
                {
                    value: '6',
                    label: '其他'
                }
            ]
        };
    },
    created() {
        this.id = this.$route.query.id;
        console.log(this.id);
        this.getSysInfoList();
    },
    methods: {
        getSysInfoList() {
            this.$axios
                .post('coupon/getData', {
                    id: this.id
                })
                .then(res => {
                    console.log(res);
                    if (res.data.code == 0) {
                        this.tableData = res.data.data;
                        // this.tableData.couponServiceImgUrl = res.data.data.couponServiceImgUrl.join(',');
                        console.log(this.tableData.couponServiceImgUrl);
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        returnPage() {
            // 跳转上一级
            // 这个判断用来解决这种情况，当用户没有上一条路由的历史记录，出现点击返回按钮没有反应时，下面的代码用来判断有没有上一条路由的历史记录   如果没有则返回首页
            if (window.history.length <= 1) {
                this.$router.push({ path: '/home' });
                return false;
            } else {
                this.$router.go(-1);
            }
        }
    }
};
</script>
<style scoped>
.el-button {
    margin-bottom: 20px;
    width: 80px;
    font-size: 14px;
    font-weight: bold;
}
.demo-image__lazy {
    text-align: center;
}
.el-select {
    width: 100%;
}
.images {
    width: 150px;
    height: 150px;
}
</style>
